import { z } from 'zod';

export const AdDto = z.object({
  ad_id: z.string(),
  ad_impression_id: z.string(),
  block: z.string(),
  block_position: z.number(),
  brand_name: z.string(),
  click_url: z.string().url(),
  cpc: z.string(),
  deal_type: z.enum(['cpa', 'cpc']),
  display_url: z.string(),
  is_above_fold: z.enum(['true', 'false']),
  metal_level: z.enum(['bronze', 'silver', 'gold', 'platinum']).optional(),
  position_in_block: z.string(),
  position_in_page: z.string(),
  premium: z.string(),
});
